export const skills = [
  {
    category: 'Programming',
    featured: true,
    items: ['Java', 'Python', 'C++', 'Haskell', 'SQL']
  },
  {
    category: 'Frameworks & Libraries',
    featured: true,
    items: ['Angular', 'TypeScript', 'JavaFX', 'JHipster', 'Spring Boot', 'scikit-learn']
  },
  {
    category: 'Core Computer Science',
    featured: false,
    items: ['Data structures and algorithms', 'Object-oriented programming', 'Operating systems', 'Computer networks', 'Cyber security']
  },
  {
    category: 'AI & Data',
    featured: true,
    items: ['Machine learning', 'NLP', 'Computer vision', 'Data analysis', 'TF-IDF']
  },
  {
    category: 'Databases & Tools',
    featured: false,
    items: ['PostgreSQL', 'JDBC', 'Git version control', 'Collaborative development workflows']
  }
]
